var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTop)?_c('a',{staticClass:"backtop",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.backtop}},[_vm._v("Top")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }